import { DeliverectOrderType } from './deliverect_order_type.js';

export function name(orderType: DeliverectOrderType): string {
  switch (orderType) {
    case DeliverectOrderType.PickUp:
      return 'Pick Up';
    case DeliverectOrderType.Delivery:
      return 'Delivery';
    case DeliverectOrderType.EatIn:
      return 'Eat In';
    case DeliverectOrderType.Curbside:
      return 'Curbside';
  }
}
